export default __webpack_public_path__ + "static/media/fevr-bm-icon-3.cb36e414.svg";